import styled from 'styled-components';

export const SMessage = styled.div`
  color: ${({ theme }) => theme.text.color.light};
`;
